var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_553",
    x: 0,
    y: 0,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#02332a",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35385",
    "data-name": "Gruppe 35385",
    transform: "translate(-897 -626)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 897, 626)",
    filter: "url(#Ellipse_553)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_553-2",
    "data-name": "Ellipse 553",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(30 20)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35384",
    "data-name": "Gruppe 35384",
    transform: "translate(-3 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_11408",
    "data-name": "Rechteck 11408",
    transform: "translate(950.5 666)",
    fill: "#fff",
    stroke: "#a5b5af",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 36,
    rx: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 34,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linie_74",
    "data-name": "Linie 74",
    y2: 8,
    transform: "translate(963 674)",
    fill: "none",
    stroke: "#a5b5af",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M10.689,14.841l3.4-3.406a.64.64,0,0,1,.908,0,.649.649,0,0,1,0,.911l-3.856,3.859a.642.642,0,0,1-.887.019L6.375,12.349a.643.643,0,1,1,.908-.911Z",
    transform: "translate(952.315 677.654)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll-down.eaff9b19d33836c7c2ac8297b19974ec.svg";
export { ForwardRef as ReactComponent };